"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
/**
 * Base abstract class denoting a basic criterion features that are common for all criteria variations.
 */
var AbstractCriterion = /** @class */ (function () {
    /**
     * Creates the criteria with initial parameters.
     * @param {!FilterItem} _filterItem - The item hosting this particular criteria.
     * @param {boolean} [_isNegating=false] - Whether the associated filtering method is negating.
     * @see FilterType
     * @see FilterTypeNegations
     */
    function AbstractCriterion(_filterItem, _isNegating) {
        if (_isNegating === void 0) { _isNegating = false; }
        this._filterItem = _filterItem;
        this._isNegating = _isNegating;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_filterItem);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_isNegating);
    }
    Object.defineProperty(AbstractCriterion.prototype, "filterItem", {
        /**
         * Returns the item hosting this criteria.
         * @returns {FilterItem} The hosting item.
         */
        get: function () {
            return this._filterItem;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCriterion.prototype, "isNegating", {
        /**
         * Check whether or not the associated filtering method has negative meaning.
         * @returns {boolean} True if negative, false otherwise.
         */
        get: function () {
            return this._isNegating;
        },
        /**
         * Specify whether or not the associated filtering method has negative meaning.
         * @param {boolean} isNegating - True if negative, false otherwise.
         */
        set: function (isNegating) {
            this._isNegating = isNegating;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * In accordance to 'visitor' pattern this method is used to provide the visitor instance.
     * @param {!CriterionVisitor} criterionVisitor - Any implementation of {@CriterionVisitor} interface.
     */
    AbstractCriterion.prototype.accept = function (criterionVisitor) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(criterionVisitor);
        criterionVisitor.visit(this);
    };
    /**
     * Method should be called by descendants when any property of those is changed, in as much as the criteria must be
     * validated in case of a change. This simulates visiting the criterion by an instance of {@link CriterionValidator}
     * which is an implementation of the aforementioned interface.
     */
    AbstractCriterion.prototype.validate = function () {
        this.accept(this._filterItem.criterionValidator);
    };
    return AbstractCriterion;
}());
exports.AbstractCriterion = AbstractCriterion;
//# sourceMappingURL=abstract-criterion.js.map